import { createSelector } from 'reselect'

const myLibrarySelector = state => state.myLibrary

const myLibraryLiveSessionMultipleCodesSelector = createSelector(
	[myLibrarySelector],
	myLibrary => ({
		codes: myLibrary.codes,
		actualTimestamp: myLibrary.actualTimestamp,
	})
)

export default myLibraryLiveSessionMultipleCodesSelector
